module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/components/auth/auth.component.html
// module id = ../../../../../src/app/components/auth/auth.component.html
// module chunks = main